// src/api/http.ts

type HttpMethod = "GET" | "POST" | "PATCH" | "DELETE";

type ApiRequestOpts = {
  tenantId?: string;
  body?: any;
  signal?: AbortSignal;
  /** Optional extra headers (e.g., admin-only endpoints can use x-admin-key). */
  headers?: Record<string, string>;
};

export class HttpError extends Error {
  status: number;
  payload: any;
  constructor(status: number, message: string, payload?: any) {
    super(message);
    this.status = status;
    this.payload = payload;
  }
}

export async function apiRequest<T = any>(
  method: HttpMethod | string,
  path: string,
  opts: ApiRequestOpts = {}
): Promise<T> {
  const headers: Record<string, string> = {
    "content-type": "application/json; charset=utf-8",
    ...(opts.headers || {}),
  };

  if (opts.tenantId) {
    headers["x-tenant-id"] = opts.tenantId;
  }

  const res = await fetch(path, {
    method,
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
    signal: opts.signal,
    credentials: "include",
  });

  let json: any = null;
  try {
    json = await res.json();
  } catch {
    // ignore non-json
  }

  if (!res.ok || (json && json.ok === false)) {
    const message =
      (json && (json.error || json.message)) || `Request failed (${res.status})`;
    throw new HttpError(res.status, message, json);
  }

  return json as T;
}
